(() => {
  'use strict';
  const emit = (name, detail = {}) => window.CorsailleAnalytics?.emit(name, detail);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cs-product-link]');
    if (!link) return;

    const card = link.closest('[data-cs-product-card]');
    if (!card) return;

    emit('product_card_click', {
      productId: card.dataset.productId,
      variantId: card.dataset.csVariantId,
      objectType: card.dataset.csObjectType,
      collection: card.dataset.csCollection,
      mediaType: card.dataset.csMediaType,
      productHandle: card.dataset.productHandle,
      category: card.dataset.family,
      source: card.dataset.context,
      position: card.dataset.position || null,
    });
  });
})();
